import { makeStyles, Menu, Typography } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ForwardToInboxTwoToneIcon from '@mui/icons-material/ForwardToInboxTwoTone';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useState } from 'react';
import axios from '../../util/axios';
import moment from 'moment-timezone';
import { TabsControllerContext } from '../../Context/Tabs/TabsProvider';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { clinicImpersonated } from '../../util/functions';
import { useNavigate } from 'react-router-dom';
import { TABS } from '../../util/constants/calendar-tabs.constants';

const defaultNumberOfNotifications=3;
const useStyles = makeStyles(() => ({
  fontFamilyAlmarai:{
    fontFamily:'Almarai !important'
  },
  fontFamilyEina: {
    fontFamily: "Eina-semi !important",
  },
  mainMenu:{
    "& .MuiPaper-root":{
     overflow:"unset"
    }
  },
  view:{
    cursor:"pointer",
    color:"#212B36",
    fontWeight:"bold",
    fontSize:"12px!important",
    opacity:0.56,
    "& svg":{
      width:'0.5em',height:'0.5em'
    }
  },
  pending:{
    fontWeight:'bold',
    opacity:0.56,
    fontSize:"12px!important",
    color:"#212B36"
  },
  clear:{
    fontWeight:'bold',
    opacity:0.56,
    fontSize:"12px!important",

    cursor:"pointer",
    color:"#C58D00"
  },
  notificationTab: {
    width: '100%',
    height: '100%',
    padding: 20
  },
  notiticationTabHeaderBox:{
  height: "30px",
  margin: 0,
  padding: "10px",
  position:"inherit",
  zIndex:2
  },
  notiticationTabHeader: {
    margin: 0,
    padding: "5px 10px",
    backgroundColor:"#F5F5F5",
    borderRadius: "4px",
    display:"flex",
   justifyContent:"space-between"
  },
  notificationsParent:{
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    overflowY:"auto",
    width: 420,
    maxWidth: "90vw",
    maxHeight: "70vh",
    paddingBottom: 8,
  },
  section: {
    padding: "4px 6px 8px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px 0",
  },
  sectionTitle: {
    color: "#212B36",
    fontWeight: "bold",
    fontSize: "15px !important",
  },
  seeAll: {
    cursor: "pointer",
    color: "#212B36",
    fontWeight: "bold",
    fontSize: "12px !important",
    opacity: 0.56,
    display: "flex",
    alignItems: "center",
    gap: 2,
    "& svg": {
      width: "0.7em",
      height: "0.7em",
    },
  },
  emptySection: {
    color: "#212B36",
    fontSize: "12px !important",
    opacity: 0.56,
    padding: "8px 12px",
  },
  notification:{
    cursor:"pointer",
    margin:"0px 10px 0 10px",
    display:"flex",
    padding:10,
    marginTop:"15px",
    borderBottom:"1px solid grey"
  },
  notificationIcon:{
    flex: "0 1 15%",
    margin:"5px 10px 0 0",
    color:"#212B36",
    "& img":{
      width:"100%",
    },
    

  },
  triangle:{
    height: "5px",
    width: "14px",
    backgroundColor: "white",
    boxShadow:" 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
    clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
    position: "absolute",
    bottom: "100%",
    right: "3%",
  },
  notificationBody:{
  },
  description:{
   color: "#303030",
  fontWeight:'bold',
  fontSize:"12px!important",
   opacity:0.8,
   maxWidth: "25vw",
   ['@media(max-width: 1000px)'] : {
    maxWidth: "35vw",
  },
  ['@media(max-width: 600px)'] : {
    maxWidth: "45vw",
  },
  ['@media(max-width: 400px)'] : {
    maxWidth: "60vw",
  },
  },
  descriptionTime:{
    color:"#C58D00",
    fontWeight:"bold",
    fontSize:"12px!important",
    opacity:0.8,
   },
   title:{
    color: "#303030",
    fontWeight:"bold",
    fontSize:"14px!important",
    opacity:0.8,
    display: 'flex',
    gap: '5px',
    alignItems:"center"
   },
   timeAgo:{
    color:"#212B36",
    fontWeight:"bold",
    fontSize:"12px!important",
    opacity:0.56
   },
   redDot:{
     color:"red !important",
     fontSize:"1em !important",
     verticalAlign: "text-top",
   },
}));
const previewCount = 2;

function ClinicNotification({anchorElNotification,openNotification,handleCloseNotificationTab,data ,commentData,setUpdate,isComment,isTime,clinicContent}) {
  const classes = useStyles()
  const navigate = useNavigate();
  const[isOpen,setIsOpen]=useState(false)
  const [expandedSection, setExpandedSection] = useState(null)
  const {
		currentTab,
		actions: { setCurrentTab, handleKeyPressPatient, setOpenNote},
	} = useContext(TabsControllerContext);
  const[sizenotifactions,setSize]=useState(defaultNumberOfNotifications)
  useEffect(()=>{
   
    if(isOpen){
      setSize(data.size_all);
    }
    else{
      setSize(defaultNumberOfNotifications);
    }
  },[isOpen])

  useEffect(() => {
    if (!openNotification) {
      setExpandedSection(null);
    }
  }, [openNotification]);

  const ClearAll=()=>{
    if(!clinicImpersonated()){
      const requests = isComment
        ? [axios.get(`/admin/v1/clinic/notifications/all?is_comment=1`)]
        : [
            axios.get(`/admin/v1/clinic/notifications/all?is_comment=0`),
            axios.get(`/admin/v1/clinic/notifications/all?is_comment=1`),
          ]
      Promise.all(requests)
        .catch((err) => console.log(err))
        .finally(() => setUpdate((n) => n + 1));
    }
  }
  const ClearNotification=(id)=>{
    if(!clinicImpersonated()){
      axios.get(`/admin/v1/clinic/notifications/${id}`)
        .catch((err) => console.log(err))
        .finally(() => setUpdate((n) => n + 1));
    }
  }
  const ViewAll=()=>{
    setIsOpen((prev)=>{
      return !prev
    })
  }
  const { t, i18n } = useTranslation()
  const fontClass = i18n.language == 'ar' ? classes.fontFamilyAlmarai : classes.fontFamilyEina
  const forwardIconStyle = i18n.language === 'ar' ? { transform: 'scaleX(-1)' } : undefined
  const showingNotes = isComment == 1
  const showingSchedule = isTime == 1
  const notifications = data?.notifications || []
  const appointmentNotifications = notifications.filter((notification) => notification.type !== 'cancel')
  const cancellationNotifications = notifications.filter((notification) => notification.type === 'cancel')
  const noteNotifications = commentData?.notifications || []
  const pendingCount = (Number(data?.pending) || 0) + (Number(commentData?.pending) || 0)

  const openNotificationItem = (notification) => {
    ClearNotification(notification.id)
    if(notification?.type == 'comment'){
        navigate(`/dashboard/users/${notification?.user_id}`,{state:{ isCommentNot : true}});
    }else if(notification?.type == 'reminder'){
      navigate(`/dashboard/users/${notification?.user_id}/edit-patient-data`);
    }else if(notification?.type == 'cancel'){
      setCurrentTab(TABS.CANCELLED_BOOKING)
      Cookies.set('currentTab', TABS.CANCELLED_BOOKING)
    }else{
      setCurrentTab(TABS.NEEDS_RESCHEDULING)
      Cookies.set('currentTab', TABS.NEEDS_RESCHEDULING)
    }
    const patientName = notification?.user?.first_name
    if (patientName) {
      handleKeyPressPatient({key:"Enter",
      target:{
        value:patientName}
      })
    }
    handleCloseNotificationTab()
  }

  const renderNotification = (notification) => (
    <div key={notification.id} className={classes.notification} onClick={() => openNotificationItem(notification)}>
      <div className={classes.notificationIcon}>
          {notification.type=="comment"?<img src='/assets/images/Note.svg'/>
          : notification.type=="reschedule"? <img src='/assets/images/Reschedule.svg'/>
          : notification.type=="cancel"?<img src='/assets/images/Cancel.svg'/>
          : <img src='/assets/images/New Appointment.svg'/>}
      </div>
      <div className={classes.notificationBody}>
        <Typography variant='h4' gutterBottom className={`${classes.title} ${fontClass}`}> {notification.read ==false &&<FiberManualRecordIcon className={classes.redDot}/>} {notification.title}</Typography>
        <Typography variant='h4' className={`${classes.description} ${fontClass}`}>{notification.description}</Typography>
        {notification.appointment_time && <Typography variant='h4' className={`${classes.descriptionTime} ${fontClass}`} gutterBottom>{(isComment || notification.type === 'comment') ? moment.utc(notification.appointment_time).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format("ddd, MMM DD [at] hh:mm A") : moment(notification.appointment_time).format("ddd, MMM DD [at] hh:mm A")}</Typography>}
        <Typography variant='h4' className={`${classes.timeAgo} ${fontClass}`} >  {moment.utc(notification?.created_at).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).fromNow()}</Typography>
      </div>
    </div>
  )

  const renderSection = (sectionKey, title, items) => {
    const expanded = expandedSection === sectionKey
    const visibleItems = expanded ? items : items.slice(0, previewCount)
    return (
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <Typography variant='h4' className={`${classes.sectionTitle} ${fontClass}`}>{title}</Typography>
          {items.length > previewCount && (
            <Typography variant='h4' className={`${classes.seeAll} ${fontClass}`} onClick={() => setExpandedSection(expanded ? null : sectionKey)}>
              {t('see-all')} {expanded ? <KeyboardArrowDownIcon/> : <ArrowForwardIosIcon style={forwardIconStyle} />}
            </Typography>
          )}
        </div>
        {visibleItems.length === 0
          ? <Typography variant='h4' className={`${classes.emptySection} ${fontClass}`}>{t('none')}</Typography>
          : visibleItems.map(renderNotification)}
      </div>
    )
  }

  return <Menu
    id="demo-positioned-menu1"
    aria-labelledby="demo-positioned-button1"
    anchorEl={anchorElNotification}
    open={openNotification}
    onClose={handleCloseNotificationTab}
    className={classes.mainMenu}
    getContentAnchorEl={null}
    anchorOrigin={{ vertical: 35, horizontal: "center" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {!showingSchedule && showingNotes &&
      <div className={classes.notiticationTabHeaderBox}>
        <div className={classes.notiticationTabHeader}>
          <Typography variant='h4' className={`${classes.pending} ${fontClass}`} display='inline'>{data.pending} {t('pending-notification')}</Typography>
          {!clinicImpersonated() && <Typography variant='h4' className={`${classes.clear} ${fontClass}`} display='inline' onClick={ClearAll}>{t('Clear-all')}</Typography>}
          <Typography variant='h4' className={`${classes.view} ${fontClass}`} display='inline' onClick={ViewAll}>{t('View-all')} { isOpen ?(<KeyboardArrowDownIcon/>):(<ArrowForwardIosIcon style={forwardIconStyle} />)}</Typography>
        </div>
      </div>
      }
      {!showingSchedule && !showingNotes &&
      <div className={classes.notiticationTabHeaderBox}>
        <div className={classes.notiticationTabHeader}>
          {pendingCount > 0 && <Typography variant='h4' className={`${classes.pending} ${fontClass}`} display='inline'>{pendingCount} {t('pending-notification')}</Typography>}
          {!clinicImpersonated() && <Typography variant='h4' className={`${classes.clear} ${fontClass}`} display='inline' onClick={ClearAll}>{t('Clear-all')}</Typography>}
        </div>
      </div>
      }
      {showingSchedule ?
          clinicContent&&<div style={{width:'450px',height:'450px',border:'0px',overflow: 'auto',margin:'10px'}}  dangerouslySetInnerHTML={{ __html: clinicContent }} />
      : showingNotes ?
      <div className={classes.notificationsParent} id={isOpen ? "opened" :""}>
        {data.size_all>0 && data.notifications.slice(0, sizenotifactions).map(renderNotification)}
      </div>
      :
      <div className={classes.notificationsParent}>
        {renderSection('appointments', t('Appointments'), appointmentNotifications)}
        {renderSection('cancellations', t('Cancellations'), cancellationNotifications)}
        {renderSection('notes', t('Notes'), noteNotifications)}
      </div>
      }
    </Menu>;
}

export default ClinicNotification;
